export default {
      id: "line-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#line-usage",
      toString: function () {
        return this.url;
      }
    }